// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4\"/> </svg> ";
// Exports
module.exports = code;